import { DataBean } from "../DataBean";

export class Labour extends DataBean {

    public async getLabourCatalog(idManufacturingStardard: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLabourCatalog_Number", [idManufacturingStardard]);
    }

    public async getLabourTimeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLabourTimeConstants_Number", [arg]);
    }

    public async updateLabour(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.productionorders.Labour_updateLabour_com.quickdataerp.bean.productionorders.Labour",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.productionorders.Labour"
                }
            ]
        );
    }

}
